/* This is the common style */
import { deepPurple } from '@material-ui/core/colors';

export const commonStyle = theme => ({
    paper: {
        padding: theme.spacing(1),
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    blockdiv: {
        textAlign: 'center'

    },
    displayFlex: {
        display: 'flex'
    }
});

export const commonStyleForEditPersonalInfo = theme => ({
    root: {
        minWidth: 190
    },
    grid: {
        display: 'flex'
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    blockdiv: {
        textAlign: 'center'

    },
    displayFlex: {
        display: 'flex'
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    paper2: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        maxWidth: '300px'
    },
    title: {
        fontSize: 14
    },
    IconColor: {
        color: 'white'
    },
    IconDwollaTick: {
        fill: 'green',
        fontSize: '60px'
    },
    IconDwollaCross: {
        fill: 'red',
        fontSize: '60px'
    }
});

export const commonStyleForDetail = theme => ({
    paper: {
        minWidth: 380,
        padding: theme.spacing(1),
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },

    displayFlex: {
        display: 'flex'
    }
});

export const indexStyle = theme => ({
    root: {
        flexGrow: 1
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 250
    },
    selectEmpty: {
        marginTop: theme.spacing(2)
    },
    wrapper: {
        width: 100 + theme.spacing(2)
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    hide: {
        display: 'none'
    }
});

export const profileStyle = theme => ({
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    large: {
        width: '150px',
        height: '150px',
        backgroundColor: deepPurple[500],
        fontSize: '60px'
    },
    IconColor: {
        color: 'rgb(0, 150, 136)'
    },
    cursor: {
        cursor: 'pointer'
    }
});
